import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, useFormik, FormikProvider } from 'formik';
import { Typography } from '@material-ui/core';

// Components
import { FileUploader } from 'components/global/fileUploader';

// Store + Core
import { BATCH_UPLOAD_FILE_TYPES } from 'core/constants';
import { batchLearner, batchLearnerClearAction } from 'store/learner/actions';
import { learnerFileSelector, uploadLearnerPercentageSelector } from 'store/learner/selectors';

// Types
export interface IBatchActivityFormValues {
  file: File;
}

export const BatchLearnerForm = (): ReactElement => {
  const dispatch = useDispatch();

  // Redux State.
  const uploadPercentage: number = useSelector(uploadLearnerPercentageSelector);
  const uploadedFile = useSelector(learnerFileSelector);

  const onClearFile = (): void => {
    dispatch(batchLearnerClearAction());
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      // API call - upload file.
      dispatch(batchLearner({ file: values as { file: File } }));
    },
  });
  const { handleSubmit } = formik;

  return (
    <FormikProvider value={formik}>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <Field
          component={FileUploader}
          fileTypes={BATCH_UPLOAD_FILE_TYPES}
          id="batchLearnerFile"
          showDropZoneSubTitle
          name="file"
          onClearFile={onClearFile}
          uploadedFile={uploadedFile}
          uploadPercentage={uploadPercentage}
        />
        <Typography variant="srOnly">
          <button tabIndex={-1}>Submit</button>
        </Typography>
      </form>
    </FormikProvider>
  );
};
